import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './PDCSelector.module.css';
import { DBDropDown, DBDropDownPDC, DBDropDownPDCWeight } from '_components';


class PatientCareCenterNoteSubjectivePDCSelector extends React.Component {

    computePdc(lift, liftFreq) {
        let key = Object.keys(this.props.pdcLookup)
            .find(x =>
                this.props.pdcLookup[x].WFXDWNO === lift
                && this.props.pdcLookup[x].WFXDWFNO === liftFreq
            );

        return key ? this.props.pdcLookup[key].WFXWPNO : undefined;
    }

    handleCurrentChange(event) {
        let curLift = this.props.dolCurrentLift;
        let curLiftFreq = this.props.dolCurrentLiftFreq;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCDOLCURRENTLIFT':
                curLift = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ':
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCDOLCURRENTLIFT')
                curLiftFreq = parseInt(event.target.value);
                break;
            default:
                break;
        }


        let pdc = this.computePdc(curLift, curLiftFreq);

        if (this.props.currentPdc !== undefined && pdc !== undefined && this.props.currentPdc.WPNO !== pdc) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        } else if (this.props.currentPdc !== undefined && pdc === undefined) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC')
        } else if (this.props.currentPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        }
    }

    render() {
        return (
            <div>
                <PatientCareCenterNoteSection id='ass_current_pdc' name='Current PDC Analysis' level={2} allowCollapse={false} >
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient currently able to <b>stand</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTSTAND'}
                                isCurrent={true}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient currently able to <b>walk</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTWALK'}
                                isCurrent={true}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 2 ? styles.wide_col : styles.wide_col_req}>Current <b>lift</b> frequency:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ'}
                                masterEntity='PTMASTERWCDOLPDCWEIGHTFREQ'
                                masterEntityKeyColumn='DWFNO'
                                masterEntitySort='DWFORDER'
                                masterEntityDisplay='DWFNAME'
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 2 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient currently able to <b>lift</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDCWeight
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLCURRENTLIFT'}
                                masterField={this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ'}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>Current PDC:</label>
                        <span className={styles.leftover_col}>
                            {this.props.currentPdc ? this.props.currentPdc.WPNAME : ''}
                        </span>
                    </div>
                </PatientCareCenterNoteSection>


            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearGoals: bindActionCreators(noteActions.clearGoals, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let hasGoals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                state.entities.notes.PTGOALS[key].GODELETED !== true
        })
        .map(key => state.entities.notes.PTGOALS[key]).length ? true : false;

    let dolCurrentLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLCURRENTLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLCURRENTLIFT;
    let dolCurrentLiftFreq = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLCURRENTLIFTFREQ :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLCURRENTLIFTFREQ;

    let jrPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQPDC;
    let curPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTPDC;

    return {
        noteId,
        noteType,
        pk,
        dolCurrentLift,
        dolCurrentLiftFreq,
        pdcLookup: state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF,
        jobReqPdc: state.entities.masterData.PTMASTERWCPDC[jrPDC],
        currentPdc: state.entities.masterData.PTMASTERWCPDC[curPDC],
        hasGoals,
        prefix: noteType === 1 ? "EV" : "NT",
        table: noteType === 1 ? "PTEVAL" : "PTNOTE"
    };
}

const connectedPatientCareCenterNoteSubjectivePDCSelector = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectivePDCSelector);
export { connectedPatientCareCenterNoteSubjectivePDCSelector as PatientCareCenterNoteSubjectivePDCSelector };

